import React from "react";
import styles from "./ImageCard.module.css";
import clsx from "clsx";
import { ImageCategory, ImageDataModel } from "../../../../../../api/responsePayload/ImagesResponse";
import CustomButton, { ButtonType } from "../../../../../../components/button/CustomButton";
import Metadata from "../../questionList/components/metaData/Metadata";

interface ImageCardProps {
  imageData: ImageDataModel,
  onDeleteImageClicked?: (id: number) => void;
}
const ImageCard: React.FC<ImageCardProps> = ({
  imageData,
  onDeleteImageClicked,
}) => {
  const handleViewImage = () => {
    window.open(
      imageData.file,
      '_blank',
      'toolbar=0,location=0,menubar=0,resizable=1,width=800,height=600'
    );
  }

  const handleOnDeleteClicked = () => {
    onDeleteImageClicked && onDeleteImageClicked(imageData.id)
  };
  return (
    <div className={clsx(styles["question-group-container"])}>
      <div className={clsx(
        styles["question-group-main"],
      )}>
        <Metadata text={`id: ${imageData.id} name: ${imageData.filename} categroy: ${ImageCategory[imageData.category]}`} />
        <div className={styles["question-container"]}>
          <div className={styles["image-container"]}>
            <img src={imageData.file} />
            <div className={styles["view-image"]} onClick={handleViewImage}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z" clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        </div>
        <div className={styles["meta-data"]}>
          <p><strong>Name: </strong>{imageData.name}</p>
          <p><strong>Description: </strong>{imageData.description}</p>
        </div>
        <div className={styles["buttons-container"]}>
          <CustomButton
            text={"Delete"}
            type={ButtonType.Reject}
            onClick={handleOnDeleteClicked}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageCard;
